module.exports = __webpack_public_path__ + "fonts/Merriweather-300-latin11.5c271de.woff2";